<template>
    <div class="userFilters">
        <button
            @click="showFilters = !showFilters"
            class="btn filter-btn filter-title"
            type="button"
            data-toggle="collapse"
            :aria-expanded="showFilters"
        >
            Twoje filtry
            <a-icon icon="Dropdown" />
        </button>
        <div class="collapse" :class="{ show: showFilters }">
            <template v-if="userFilters && userFilters.length > 0">
                <div
                    v-for="(filter, idx) in userFilters"
                    class="filter-custom"
                    :key="idx"
                >
                    <button
                        type="button"
                        class="btn btn-text"
                        :style="
                            filter.id === userFilter ? 'font-weight: 700' : ''
                        "
                        @click="loadUserFilter(filter.id)"
                    >
                        <span>{{ filter.name }}</span>
                    </button>

                    <v-popover placement="right" offset="16">
                        <button type="button" class="btn btn-sm btn-auto">
                            <a-icon icon="Close" />
                        </button>

                        <template slot="popover">
                            <popover-confirm
                                message="Czy na pewno chcesz usunąć filtr?"
                                confirmText="Tak"
                                @confirmed="removeUserFilter(filter.id)"
                            />
                        </template>
                    </v-popover>
                </div>
            </template>
            <template v-else>
                <span class="ml-2">Brak zapisanych filtrów</span>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showFilters: false
        }
    },
    props: {
        moduleName: {
            type: String,
            required: true
        }
    },
    computed: {
        userFilters() {
            return this.$store.getters.getUserFilters
        },
        userFilter() {
            return this.$store.getters.getUserFilter
        }
    },
    methods: {
        async loadUserFilter(value) {
            this.$store.dispatch('setUserFilters', {
                id: value,
                moduleName: this.moduleName
            })
            this.$store.dispatch('setUserFilter', value)
            await this.$store.dispatch('loadPromoGroups', {
                noCancel: false
            })

            this.$store.dispatch('addNotification', {
                type: 'success',
                content: 'Załadowano filtry'
            })
        },
        async removeUserFilter(value) {
            await this.$store.dispatch('removeUserFilter', { id: value })
            this.$store.dispatch('loadUserFilters')
        }
    }
}
</script>
